import { BrowserModule }         from '@angular/platform-browser';
import { NgModule }              from '@angular/core';
import { HttpModule, Http }      from '@angular/http';
import { TranslateService,
         TranslateModule,
         TranslateLoader,
         TranslateStaticLoader } from 'ng2-translate/ng2-translate';
import { Ng2UiAuthModule,
         CustomConfig }          from 'ng2-ui-auth';

import { AppComponent }          from './app.component';
import { DragulaModule }         from 'ng2-dragula/ng2-dragula';

import { CoreModule }            from './core/core.module';
import { LayoutModule }          from './layout/layout.module';
import { SharedModule }          from './shared/shared.module';
import { RoutesModule }          from './routes/routes.module';
import { ServicesModule }        from './services/services.module';

import Config                    from './services/configuracion/config';
import { MyTranslatePipe } from './pipes/my-translate.pipe';
import {MyTranslateModule} from './modules/my-translate-module/my-translate-module';

// https://github.com/ocombe/ng2-translate/issues/218
export function createTranslateLoader(http: Http) {
    return new TranslateStaticLoader(http, './assets/i18n', '.json');
}

export class MyAuthConfig extends CustomConfig {
  loginUrl              = [Config.ApiUrl, 'usuario/login'].join('/');
  signupUrl             = [Config.ApiUrl, 'usuario/signup'].join('/');
  calificacionUrl       = [Config.ApiUrl, 'calificacion/calificacion-incidencia'].join('/');
  defaultHeaders        = {'Content-Type': 'application/json'};
  authHeader            = 'X-Access-Token';
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    DragulaModule,
    BrowserModule,
    CoreModule,
    LayoutModule,
    SharedModule.forRoot(),
    RoutesModule,
    ServicesModule,
    MyTranslateModule,
    Ng2UiAuthModule.forRoot(MyAuthConfig),
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [Http]
    }),
  ],
  providers: [],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule { }





// WEBPACK FOOTER //
// ./src/app/app.module.ts